export default "__VITE_ASSET__C3eK$5Jr__"